module.exports = __webpack_public_path__ + "static/media/cred-2.b150c9bf.gif";